import { Module, Action } from "vuex-module-decorators";
import { httpServer as http } from "@/http/tbrScanAxios";

@Module({ name: "K2AppealModule", namespaced: true })
export default class K2AppealModule {
  @Action
  async queryAppealList(params) {
    const res = await http("/k2-scan/k2-app/scan-appeal/query-appeal", params);
    return res;
  }
}
